import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import type { ApiError } from '@/types';

function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    'title' in error
  );
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000, // 30 seconds
        gcTime: 5 * 60 * 1000, // 5 minutes (formerly cacheTime)
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) {
            return false; // Don't retry client errors
          }
          return failureCount < 3;
        },
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        // Global error handling for queries
        console.error(`Query ${JSON.stringify(query.queryKey)} failed:`, error);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        // Global error handling for mutations
        console.error(`Mutation ${mutation.mutationId} failed:`, error);
      },
    }),
  });
}

export const queryClient = createQueryClient();
